import React from 'react';
import styled, { css } from 'styled-components';
// --------------------------------------------------------------------------------
import { config } from '../index';

export interface StringProps {
  /* String html tag type */
  Tag?: TagProps;
  /* String text | value */
  string?: string;
  /* String color */
  color?: string;
  /* String font size */
  fontSize?: string;
  /* String font weight */
  fontWeight?: string;
  /* String line height */
  lineHeight?: string | number;
  /* String text align property */
  align?: string;
  /* String text length limit */
  limit?: number;
  /* String margin */
  margin?: string;
  /* String padding */
  padding?: string;
  /* String width */
  width?: string;
  /* String additional class props */
  className?: string;
  /* String order in UI value */
  order?: number;
  /* String pointer value */
  cursor?: string;
  /* String opacity */
  opacity?: number;
  /* Header onClick callBack */
  onClick?: (event?: MouseEvent) => void;
}

export enum TagProps {
  // HTML text formatting tags
  b = 'b',
  em = 'em',
  i = 'i',
  small = 'small',
  strong = 'strong',
  sub = 'sub',
  sup = 'sup',
  ins = 'ins',
  del = 'del',
  mark = 'mark',
  // standard text tags
  p = 'p',
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
}

const StyledString = styled.div<StringProps>`
  color: ${(props) => props.color};
  font-size: ${(props) => props.fontSize};
  line-height: ${(props) => props.lineHeight};
  font-weight: ${(props) => props.fontWeight};
  text-align: ${(props) => props.align};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  order: ${(props) => props.order};
  cursor: ${(props) => props.cursor};
  opacity: ${(props) => props.opacity};

  ${({ limit }) =>
    limit &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limit}; /* number of lines to show */
      -webkit-box-orient: vertical;
    `}
`;

export const String: React.FC<StringProps> = ({
  Tag = TagProps.p,
  string,
  color = config.darkMuted,
  fontSize = config.fontMedium,
  fontWeight,
  lineHeight = 'initial',
  align = 'start',
  limit,
  margin,
  padding,
  width,
  order = 0,
  cursor = 'default',
  opacity = 1,
  onClick,
  // additional props
  ...props
}) => {
  if (!string) return null;

  return (
    <StyledString
      className="dm-font" // ⚠️ default font family
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      align={align}
      limit={limit}
      margin={margin}
      padding={padding}
      width={width}
      order={order}
      cursor={cursor}
      opacity={opacity}
      onClick={() => onClick?.()}
      // any additional props that override the defaults
      {...props}
    >
      <Tag style={{ padding: 0, margin: 0 }}>{string}</Tag>
    </StyledString>
  );
};
